/**
 * Custom cursor (dot + lerped ring). Desktop fine-pointer only, respects reduced motion.
 * Expands + labels on any element with data-cursor="LABEL".
 */
(function () {
  function init() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var dot = document.querySelector('[data-cursor-dot]');
    var ring = document.querySelector('[data-cursor-ring]');
    if (!dot || !ring) return;

    document.documentElement.classList.add('custom-cursor');

    var mouseX = window.innerWidth / 2;
    var mouseY = window.innerHeight / 2;
    var ringX = mouseX;
    var ringY = mouseY;
    var LERP = 0.15;
    var active = false;

    window.addEventListener('mousemove', function (e) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (!active) {
        active = true;
        dot.style.opacity = '1';
        ring.style.opacity = '1';
      }
      dot.style.transform = 'translate(' + mouseX + 'px,' + mouseY + 'px) translate(-50%,-50%)';
    }, { passive: true });

    window.addEventListener('mouseleave', function () {
      dot.style.opacity = '0';
      ring.style.opacity = '0';
    });

    function raf() {
      ringX += (mouseX - ringX) * LERP;
      ringY += (mouseY - ringY) * LERP;
      ring.style.transform = 'translate(' + ringX + 'px,' + ringY + 'px) translate(-50%,-50%)';
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    document.addEventListener('mouseover', function (e) {
      var target = e.target.closest && e.target.closest('[data-cursor]');
      if (target) {
        ring.classList.add('is-expanded');
        ring.textContent = target.getAttribute('data-cursor');
      }
    });
    document.addEventListener('mouseout', function (e) {
      var target = e.target.closest && e.target.closest('[data-cursor]');
      if (target) {
        ring.classList.remove('is-expanded');
        ring.textContent = '';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
